// WebSocketProvider.js
import React, { createContext, useEffect, useRef, useState } from "react";

export const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const wsRef = useRef(null);
  let pingInterval = useRef(null)
  const [message, setMessage] = useState(null);
  const runningsettingwebsoket = () => {
    if (wsRef.current){
clearInterval(pingInterval.current)
      wsRef.current = null;
    } ; // prevent duplicate connections
    const WebSocketurl =
      process.env.REACT_APP_WSS_URL;

    wsRef.current = new WebSocket(WebSocketurl);

    wsRef.current.onopen = () => {
      console.log("✅ WebSocket connected");

      wsRef.current.send(
        JSON.stringify({
          event: "pusher:subscribe",
          data: { channel: "settings" },
        })
      );

      // keep-alive ping
       pingInterval.current = setInterval(() => {
        if (wsRef.current?.readyState === WebSocket.OPEN) {
          wsRef.current.send(
            JSON.stringify({ event: "pusher:ping", data: {} })
          );
        }
      }, 1000);

      wsRef.current.onclose = () => {
        clearInterval(pingInterval.current);
        console.log("❌ WebSocket closed");
      };
    };

    wsRef.current.onmessage = (event) => {
      try {
        const parsed = JSON.parse(event.data);
        if (!parsed?.channel) return;
        if (parsed && typeof parsed === "object") {
          setMessage(JSON.parse(parsed.data)); // ✅ only JSON objects will update state
        }
      } catch {
        // ❌ if not valid JSON → ignore
        console.warn("⚠️ Ignored non-JSON WebSocket message:", event.data);
      }
    };

    return () => {
      wsRef.current?.close();
      wsRef.current = null;
    };
  };
    useEffect(() => {
      const handleFocus = async () => {
        if (!document.hidden) {
        runningsettingwebsoket()
        console.log("runningsettingwebsoket")
        }
      };
  
      window.addEventListener("visibilitychange", handleFocus);
  
      return () => {
        window.removeEventListener("visibilitychange", handleFocus);
  
        // cleanup root on unmount
       
      };
    }, []);
  useEffect(() => {
    runningsettingwebsoket();
  }, []);

  return (
    <WebSocketContext.Provider value={{ ws: wsRef.current, message }}>
      {children}
    </WebSocketContext.Provider>
  );
};
